import React, { useState, useEffect } from "react";
import {
  MdPerson,
  MdLock,
  MdNotificationsActive,
  MdContactSupport,
  MdLogout,
  MdHome,
  MdCreditCard
} from "react-icons/md";
import { useDispatch } from "react-redux";

import { Link, useNavigate, useLocation } from "react-router-dom";
import { logOutAsync } from "../../store/asyncLogout";
import { useAddToHomescreenPrompt } from "../../hooks/useAddToHomescreenPrompt";
import { Button, Modal } from "antd";
import SupportForm from "./SupportForm";

const ProfileSectionHolder = ({ embedded = false, onSelect, activeSection }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = JSON.parse(localStorage.getItem('user'))
  const [promptToInstall, isIOS, isInstallable] = useAddToHomescreenPrompt();
  const [supportOpen, setSupportOpen] = useState(false);

  const handleLogoutClick = () => {
    dispatch(logOutAsync());
    localStorage.removeItem("user");
    localStorage.removeItem("session");
    navigate('/login')
  };

  const ProfileSection = ({ user, Icon, title, subtitle, onClick, disabled }) => {
    if (embedded) return (
      <Button type="text" icon={<Icon size={24} />} disabled={disabled} onClick={onClick}
        aria-pressed={activeSection === title} className="w-full !h-auto min-h-11 !justify-start !whitespace-normal !text-left !py-3">
        {title}
      </Button>
    );
    return (
      <div
        onClick={disabled? ()=>{}: onClick}
        className={` ${!disabled && "cursor-pointer"} flex text-[#585858] justify-between items-center p-4 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <div className="flex items-center gap-3">
          <Icon className=' size-[24px] font-medium' color="#AAAAAA" />
          <p className=" text-[#585858] text-[15px]">{title}</p>
        </div>
        <p className=" [#b1b1b1] text-[14px] text-[#757575] font-medium">{subtitle}</p>
      </div>
    );
  };
  return (
    <div className={embedded ? "w-full min-w-0" : "lg:hidden mx-auto -lg w-full bg-[#FFFFFF] border-[1px] border-[#E4E4E4] rounded-xl"}>
      <div className=" flex-wrap gap-[2%]">
        <ProfileSection
          Icon={MdPerson}
          title="Profile Information"
          subtitle=""
          onClick={()=>{embedded ? onSelect?.("profileinfo") : navigate("/myprofile/profileinfo")}}
        />
        <hr className="" />
        <ProfileSection Icon={MdCreditCard} title="Subscription" subtitle="" onClick={() => { embedded ? onSelect?.("subscription") : navigate("/myprofile/subscription") }} />
        <hr className="" />
        <ProfileSection
          Icon={MdLock}
          title="Password Security"
          subtitle=""
          onClick={()=>{embedded ? onSelect?.("changepass") : navigate("/myprofile/changepass")}}
          disabled={user?.loginType !== 'EMAIL'}
        />
        <hr className="" />
        <ProfileSection
          Icon={MdNotificationsActive}
          title="Notification"
          subtitle=""
          disabled={true}
        />{/* TODO: remove disabled as true after notification is implemented */}
        <hr className="" />
        {(isInstallable || isIOS) && (
          <>
            <ProfileSection
              Icon={MdHome}
              title="Add to Home"
              subtitle={isIOS ? "Tap share to install" : isInstallable ? "Click to install" : "Not available"}
              onClick={promptToInstall}
              disabled={!isIOS && !isInstallable}
            />
            <hr className="" />
          </>
        )}
        <ProfileSection
          Icon={MdContactSupport}
          title="Support"
          subtitle=""
          onClick={() => { embedded ? onSelect?.("support") : setSupportOpen(true) }}
        />
        <hr className="" />
        <ProfileSection
          Icon={MdLogout}
          title="Log Out"
          onClick={handleLogoutClick}
        />{/* TODO: remove disabled as true after notification is implemented */}
      </div>
      {!embedded && <Modal open={supportOpen} onCancel={() => setSupportOpen(false)} footer={null} destroyOnClose>
        <SupportForm onDone={() => setSupportOpen(false)} />
      </Modal>}
    </div>
  );
};

export default ProfileSectionHolder;
